import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Inscription, Preloader, RoundPendingIcon, useResponsive } from '@common-fe/common-fe';

import AppButton from '@/components/controls/AppButton';

interface Props {
  isLoading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const LockCardConfirmDialog: React.FC<Props> = ({ isLoading, onCancel, onConfirm }) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();

  return (
    <Box direction="column" align="center" data-testid="lock-card-confirm-dialog">
      <Box align="center" justify="center" width="72px" height="72px">
        <RoundPendingIcon size="48px" color="warning" />
      </Box>
      <Box margin={{ top: 'spacing16', bottom: 'spacing8' }}>
        <Inscription
          size="2xl"
          color="textTitle"
          weight="bold"
          lineHeight="32px"
          textAlign="center"
        >
          {t('Are you sure that you want to lock this card?')}
        </Inscription>
      </Box>
      <Box margin={{ bottom: 'l' }}>
        <Inscription
          color="textBody"
          textAlign="center"
          lineHeight="20px"
        >
          {t('You can unlock this card at any time.')}
        </Inscription>
      </Box>
      <Box
        direction={isMobile ? 'column' : 'row'}
        align="center"
        justify="center"
        width={isMobile ? '100%' : undefined}
        gap="xs"
      >
        <AppButton
          buttonType="secondary"
          width={isMobile ? '100%' : '140px'}
          type="button"
          testId="lock-card-confirm-dialog_cancel-button"
          onClick={onCancel}
        >
          {t('Cancel')}
        </AppButton>
        <AppButton
          disabled={isLoading}
          type="button"
          color="red"
          width={isMobile ? '100%' : '140px'}
          testId="lock-card-confirm-dialog_confirm-button"
          onClick={onConfirm}
        >
          {isLoading ? <Preloader color="white" /> : t('Confirm')}
        </AppButton>
      </Box>
    </Box>
  );
};

export default LockCardConfirmDialog;
